import {Queries} from '../../api/queries';
import Layout from '../Layout';
import ProjectFiles from './ProjectFiles';
import ProjectNotes from './ProjectNotes';
import ProjectOverview from './ProjectOverview';
import ProjectTransactions from './ProjectTransactions';
import {Tabs} from '@sproutsocial/racine';
import {useQuery} from '@tanstack/react-query';
import React, {useCallback} from 'react';
import {useNavigate} from 'react-router';

export type ViewProjectTab = 'overview' | 'transactions' | 'notes' | 'files';
export const ViewProjectTabs: ViewProjectTab[] = ['overview', 'transactions', 'notes', 'files'];

interface ViewProjectProps {
	projectId: string;
	selectedTab: ViewProjectTab;
}

const ViewProject = ({projectId, selectedTab}: ViewProjectProps) => {
	const {data: project} = useQuery(Queries.project(projectId));

	const navigate = useNavigate();
	const onTabSelected = useCallback(
		(newTab: ViewProjectTab) => {
			navigate(`/projects/${projectId}/${newTab}`);
		},
		[navigate, projectId],
	);

	if (!project) {
		return null;
	}

	return (
		<Layout>
			<Layout.Header title={project.name} />
			<Layout.Body>
				<Tabs
					onSelect={onTabSelected as () => string}
					selectedId={selectedTab}
					fullWidth
					mb='space.400'
				>
					<Tabs.Button id='overview'>Overview</Tabs.Button>
					<Tabs.Button id='transactions'>Transactions</Tabs.Button>
					<Tabs.Button id='notes'>Notes</Tabs.Button>
					<Tabs.Button id='files'>Files</Tabs.Button>
				</Tabs>

				{selectedTab === 'overview' && <ProjectOverview projectId={projectId} />}
				{selectedTab === 'transactions' && <ProjectTransactions projectId={projectId} />}
				{selectedTab === 'notes' && <ProjectNotes projectId={projectId} />}
				{selectedTab === 'files' && <ProjectFiles projectId={projectId} />}
			</Layout.Body>
		</Layout>
	);
};

export default ViewProject;
